import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { Link } from "react-router-dom";
import { renderselectapi } from "../../Components/Forms/renders";
import Logboekenmenu from "../../Pages/Logboeken/menu";
import Faciliteitensidebar from "../../Pages/Faciliteiten/menu";
import Activiteitensidebar from "../../Pages/Activiteiten/menu";
import Bieppsidebar from "../../Pages/Biepp/menu";
import AdministratieMenu from "../../Pages/Admin/menu";
import SensorSidebar from "../../Pages/Sensors/menu";
import { update } from "../../Pages/Admin/Gebruikers/Reducers/actions";
import GastMenu from "../../Pages/GastenVerbruik/menu";
import ItemsMenu from "../../Pages/Items/menu";
import EvenementenMenu from "../../Pages/Evemenenten/menu";
import ErvaringenMenu from "../../Pages/Ervaringen/menu";
import BoekingenMenu from "../../Pages/Boekingen/menu";
import CMSMenu from "../../Pages/CMS/menu";
import VacaturesMenu from "../../Pages/Vacatures/menu";
import ArrangementenMenu from "../../Pages/Arrangementen/menu";
import AccommodatiesMenu from "../../Pages/Accommodaties/menu";
import KamperenMenu from "../../Pages/Kamperen/menu";
import FacilityManagementMenu from "../../Pages/FacilityManagement/menu";
import PreventiefOnderhoudMenu from "../../Pages/PreventiefOnderhoud/menu";
class Sitebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jaar: "",
      activeMenu: null,
    };
  }

  componentDidMount() {
    this.setState({ jaar: this.props.jaar });
    this.props.initialize({ jaar: this.props.jaar });
  }
  onchangeitem = (vals) => {
    this.props.update(this.props.username._id, { bedrijf: vals.target.value }).then((data) => {
      if (data.type === "GEBRUIKER_ERROR") {
        alert(data.payload);
        return false;
      } else {
        window.location.reload();
      }
    });
    //this.props.setjaar(vals.target.value);
  };

  handleMenuToggle = (menuName) => {
    this.setState(prevState => ({
      activeMenu: prevState.activeMenu === menuName ? null : menuName
    }));
  };

  handleCloseAllMenus = () => {
    this.setState({ activeMenu: null });
  };

  render() {
    const { username, token, bedrijven } = this.props;
    const { activeMenu } = this.state;

    return (
      <aside className="sneat-sidebar">
        <Link to="/" className="sneat-sidebar-brand">
          <div className="sneat-sidebar-header">
            <img src="/brand/logo_small.png" alt="Logo Recraplan" height="32" />
            <span className="logo-text">Recraplan</span>
          </div>
        </Link>
        {/* User Info Panel */}
        {token.role === "admin" && bedrijven.length > 1 && (
          <div className="sneat-user-info pt-0">
            <div className="mt-0">
              <Field className="form-select form-select-sm" name="jaar" component={renderselectapi} onChange={this.onchangeitem} options={bedrijven} />
            </div>
          </div>
        )}

        {/* Navigation Menu */}
        {username.role && (
          <nav className="sneat-menu">
            <div className="menu-header">Hoofdmenu</div>

            <div className="menu-item">
              <Link to="/" className="menu-link" onClick={this.handleCloseAllMenus}>
                <span className="menu-icon">
                  <i className="fas fa-home"></i>
                </span>
                <span className="menu-text">Dashboard</span>
              </Link>
            </div>

            {/* Dynamic Menu Items */}
            <KamperenMenu 
              token={token} 
              username={username} 
              isActive={activeMenu === 'kamperen'} 
              onToggle={() => this.handleMenuToggle('kamperen')} 
            />
            <AccommodatiesMenu 
              token={token} 
              username={username} 
              isActive={activeMenu === 'accommodaties'} 
              onToggle={() => this.handleMenuToggle('accommodaties')} 
            />
            <GastMenu 
              token={token} 
              username={username} 
              isActive={activeMenu === 'gasten'} 
              onToggle={() => this.handleMenuToggle('gasten')} 
            />
            <Activiteitensidebar 
              token={token} 
              username={username} 
              isActive={activeMenu === 'activiteiten'} 
              onToggle={() => this.handleMenuToggle('activiteiten')} 
            />
            <Bieppsidebar 
              token={token} 
              username={username} 
              isActive={activeMenu === 'biepp'} 
              onToggle={() => this.handleMenuToggle('biepp')} 
            />
            <Faciliteitensidebar 
              token={token} 
              username={username} 
              isActive={activeMenu === 'faciliteiten'} 
              onToggle={() => this.handleMenuToggle('faciliteiten')} 
            />
            <FacilityManagementMenu 
              token={token} 
              username={username} 
              isActive={activeMenu === 'facility'} 
              onToggle={() => this.handleMenuToggle('facility')} 
            />
            <PreventiefOnderhoudMenu 
              token={token} 
              username={username} 
              isActive={activeMenu === 'preventief-onderhoud'} 
              onToggle={() => this.handleMenuToggle('preventief-onderhoud')} 
            />
            <Logboekenmenu 
              token={token} 
              username={username} 
              isActive={activeMenu === 'logboeken'} 
              onToggle={() => this.handleMenuToggle('logboeken')} 
            />
            <ItemsMenu 
              token={token} 
              username={username} 
              isActive={activeMenu === 'items'} 
              onToggle={() => this.handleMenuToggle('items')} 
            />
            <EvenementenMenu 
              token={token} 
              username={username} 
              isActive={activeMenu === 'evenementen'} 
              onToggle={() => this.handleMenuToggle('evenementen')} 
            />
            <BoekingenMenu 
              token={token} 
              username={username} 
              isActive={activeMenu === 'boekingen'} 
              onToggle={() => this.handleMenuToggle('boekingen')} 
            />
            <ErvaringenMenu 
              token={token} 
              username={username} 
              isActive={activeMenu === 'ervaringen'} 
              onToggle={() => this.handleMenuToggle('ervaringen')} 
            />
            <ArrangementenMenu 
              token={token} 
              username={username} 
              isActive={activeMenu === 'arrangementen'} 
              onToggle={() => this.handleMenuToggle('arrangementen')} 
            />
            <CMSMenu 
              token={token} 
              username={username} 
              isActive={activeMenu === 'cms'} 
              onToggle={() => this.handleMenuToggle('cms')} 
            />
            <VacaturesMenu 
              token={token} 
              username={username} 
              isActive={activeMenu === 'vacatures'} 
              onToggle={() => this.handleMenuToggle('vacatures')} 
            />
            <SensorSidebar 
              token={token} 
              username={username} 
              isActive={activeMenu === 'sensors'} 
              onToggle={() => this.handleMenuToggle('sensors')} 
            />

            <div className="menu-header">Beheer</div>
            <AdministratieMenu 
              token={token} 
              username={username} 
              isActive={activeMenu === 'admin'} 
              onToggle={() => this.handleMenuToggle('admin')} 
            />
          </nav>
        )}
      </aside>
    );
  }
}
function mapStateToProps(state) {
  return {
    username: state.auth.user,
    token: state.auth.token,
    profile: state.profile,
    jaar: state.logboeken.jaar,
    bedrijven: state.bedrijven.items,
  };
}

Sitebar = reduxForm({
  form: "kiesjaar", // a unique identifier for this form
})(Sitebar);

// You have to connect() to any reducers that you wish to connect to yourself
Sitebar = connect(mapStateToProps, { update })(Sitebar);

export default Sitebar;
